import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageCloud: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageCloud"><Path d="M16.75 16C17.8279 16 18.759 16.6204 19.21 17.5225C19.3048 17.5086 19.4016 17.5 19.5 17.5C20.6046 17.5 21.5 18.3954 21.5 19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H16.75C15.2312 21.5 14 20.2688 14 18.75C14 17.2312 15.2312 16 16.75 16Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 21.5H4.5V2.5H19.5V13" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageCloud;
